<template>
    <div>
        <template v-if="detailId">
            <div class="page-title">编辑问卷</div>
        </template>
        <template v-else>
            <div class="page-title">新增问卷</div>
        </template>

        <a-spin :spinning="loading">

            <pay-box class="qa-box" title="基础设置">

                <div>
                    <span class="mr-4">是否强制预留授权用户手机</span>
                    <a-radio-group v-model="detail.need_phone">
                        <a-radio :value="1">预留</a-radio>
                        <a-radio :value="0">不预留</a-radio>
                    </a-radio-group>
                </div>


            </pay-box>

            <pay-box class="qa-box" title="问卷标题">
                <input v-model="detail.title" class="qa-text title-area" placeholder="请输入不超过100字的标题" :maxLength="100" />
                <span class="text-count">{{ detail.title.length }}/100</span>
            </pay-box>
            <pay-box class="qa-box" title="问卷描述">
                <a-textarea class="qa-text" v-model="detail.summary"
                    placeholder="请输入问卷描述信息，描述信息主要为答题者表述本问卷的调查目的或对答题人的要求等信息" :maxLength="200" autoSize></a-textarea>
                <span class="text-count">{{ detail.summary.length }}/200</span>
            </pay-box>
            <pay-box title="问卷内容" :subTitle="'(共'+detail.questions.length + '题)'" v-if="detailId">
                <question :questions="detail.questions" @saveSort="saveSort" @edit="editQuestion" @insert="insertQuestion" />

                <div class="new-q flex flex-center" @click="addQuestion">
                    <div v-if="detail.questions.length">点击此处继续添加题目</div>
                    <div v-else>点击此处添加题目</div>
                    <img src="/assets/icons/new-question-finger.png">
                </div>
            </pay-box>

            <a-affix :offset-bottom="0">
                <div class="foot-btns">
                    <button class="btn mr-8" @click="preview">预览</button>
                    <button class="btn mr-8" @click="saveChange()">保存</button>
                    <button class="btn btn-white" @click="back">返回列表</button>
                </div>
            </a-affix>
        </a-spin>

        <!-- <img v-if="miniCode" @load="qrLoad" class="preload-img" :src="miniCode + '&t=' + t" alt="">

        <a-modal v-model="showMiniCodeModal" :footer="null" width="406px">
            <div slot="title" class="text-center" v-if="detail">{{ detail.title }}</div>
            <div class="mini-qrcode-container flex flex-center">
                <small>扫码预览问卷</small>
                <br>
                <img v-if="miniCode" :src="miniCode" alt="">
                <br>
                <small>预览问卷仅查看不可填写</small>
            </div>
        </a-modal> -->
        <preview ref="preview"></preview>
        <edit-question ref="editQuestion" :qa_id="Number(detailId)" @delete="delChange" @insert="insertChange" @fetchDetail="fetchDetail" />
    </div>
</template>

<script>

import Preview from "@/views/AST/Q&A/Com/preview.vue";
import Question from "@/views/AST/Q&A/Com/Question.vue";
import EditQuestion from "@/views/AST/Q&A/Com/EditQuestion.vue";
import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
import api from "@/repo/api";

export default {
    name: "Detail",
    components: { Preview, PayBox, Question, EditQuestion },
    data() {
        return {
            detail: {
                title: "",
                summary: "",
                questions: [],
                need_phone: 0,
            },
            detailId: 0,
            loading: false,
            showMiniCodeModal: false,
            miniCode: undefined,
            t: 0,
            routeMatch:"/ast/qas",
        }
    },
    mounted() {
        this.detailId = this.$route.params.id;

        if (this.detailId) {
            this.fetchDetail()
        }
    },
    methods: {
        qrLoad() {
            this.$loading.hide()
            this.showMiniCodeModal = true
        },
        activeMiniCode() {

            this.$loading.show()
            this.t++;
            setTimeout(() => {
                this.miniCode = this.$qrcode(
                    "packagesC/questionnaireDetail/questionnaireDetail?id=" + this.detail.id,
                    `问卷小程序码-${this.detail.id}`
                );
            }, 50)
        },
        fetchDetail() {
            this.loading = true

            api.get('/ast-qa/detail', { id: this.detailId }, res => {
                this.loading = false

                this.detail = res.data

                this.$forceUpdate()
            })
        },
        // preview() {
        //     this.saveChange(true, () => {
        //         this.fetchDetail()
        //         this.activeMiniCode()
        //     })
        // },
        preview() {
            this.$refs.preview.getDetail(this.detailId);
        },
        saveSort(newList) {
            // newList是id的数组，根据newList的顺序重新排序this.detail.questions
            let newQuestions = newList.map(id => {
                const question = this.detail.questions.find(q => q.id === id);
                return question || null;
            }).filter(Boolean); // 过滤掉null值
            
            // 确保所有问题都被正确排序
            if (newQuestions.length > 0) {
                this.$set(this.detail, 'questions', newQuestions);
            }

            if (newList && newList.length > 0) {
                this.submitSort(newList)
            }
        },
        submitSort(sorts) {
            let params = {
                qa_id: this.detailId,
                sorts
            }
            api.post('/ast-qa/sort-question', params, res => {
                if (res.code !== 0) return this.$message.error(res.msg || '排序失败');
                this.updateQuestions(sorts);
            })
        },
        // 编辑问题
        editQuestion(question) {
            this.$refs.editQuestion.init(question);
            this.showQuestionModal = true;
        },
        // 插入问题
        insertQuestion(idx) {
            console.log(idx);
            this.$refs.editQuestion.insert(idx);
            this.showQuestionModal = true;
        },
        // 添加问题
        addQuestion() {
            this.$refs.editQuestion.init();
            this.showQuestionModal = true;
        },
        // 删除问题回调
        delChange(id) {
            let index = this.detail.questions.findIndex(q => q.id === id)
            if (index !== -1) {
                this.detail.questions.splice(index, 1)
            }
        },
        // 插入问题回调
        insertChange(index,question) {
            console.log('insertChange',index,question);
            this.detail.questions.splice(index+1, 0, question);
            // 排序
            this.saveSort(this.detail.questions.map(q => q.id));
        },
        saveChange(notBack, success) {
            // 验证标题和描述
            if (!this.detail.title.trim()) {
                this.$message.error('请输入问卷标题')
                return
            }
            if (!this.detail.summary.trim()) {
                this.$message.error('请输入问卷描述')
                return
            }
            this.$loading.show()
            if (!this.detailId) {
                notBack = true;
            }
            api.post('/ast-qa/sync-basic', this.detail, res => {

                this.$loading.hide()

                if (res.code !== 0) return this.$message.error(res.msg || '保存失败');
                
                this.detail.id = res.data.id
                this.detailId = res.data.id
                this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
                
                if ((!notBack)) {
                    this.$router.push('/ast/qas')
                }

                if (success) success()

            })

        },
        back() {
            this.$router.back()
        },
        updateQuestions(sorts) {
            console.log('sorts',sorts);
            // sorts 是id数组，根据id重新排序this.detail.questions
            let newArr = [];
            sorts.forEach(id => {
                let q = this.detail.questions.find(q => q.id == id);
                if (q) newArr.push(q);
            })
            console.log('newArr',newArr);
            
            this.$set(this.detail, 'questions', newArr);
            this.$forceUpdate();
        },
    }
}
</script>

<style scoped lang="less">
.question {
    margin-bottom: 24px;
}

.new-q {
    width: 100%;
    height: 102px;
    background: #F7F7F7;
    margin: 0 auto;

    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    flex-direction: column;
    cursor: pointer;

    img {
        margin-top: 4px;
        width: 30px;
        height: 30px;
    }
}

.qa-box /deep/ .ast-pay-body {
    line-height: 0;
    position: relative;
}

.qa-text {
    resize: none;
    border: none;
    outline: none;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    width: 100%;
    padding: 0;
    height: 20px;
    min-height: 20px;
    box-shadow: none !important;
}

.foot-btns {
    background-color: white;
    padding-bottom: 30px;
    padding-top: 30px;
}

.text-count {
    position: absolute;
    right: 24px;
    bottom: 37px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
}

.mini-qrcode-container {
    flex-direction: column;

    img {
        width: 256px;
        height: 256px;
    }
}
</style>